import CollapsibleInfo from './CollapsibleInfo'

export { CollapsibleInfo }



// WEBPACK FOOTER //
// ./src/Components/Elements/Collapsiblenfo/index.js